export default __webpack_public_path__ + "0e20bc42ac173c586b7033c83e1cd5f8.svg";